 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import * as Parse from "parse";


export function getUserProfile(
  user = Parse.User.current()
) {
  return (_optionalChain([user, 'optionalAccess', _ => _.get, 'call', _2 => _2("rsProfile"), 'optionalAccess', _3 => _3.toJSON, 'call', _4 => _4()]) ) || {};
}
